module.exports = __webpack_public_path__ + "static/media/magnifying-glass-icon.c7f52280.svg";